// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BGDL","error":"styles_error__2GyEU","success":"styles_success__24gJr"};